import { useSelector } from "react-redux";
import useTranslationHook from "../../../components/hooks/useTranslationHook";
import DOMPurify from "dompurify";

function Faq({
    faq = []
}) {
    const { t } = useTranslationHook();
    const lang = useSelector((state) => state.translation.lang);
    const sanitizedText = (text) => ({
        __html: DOMPurify.sanitize(text),
    });

    return (
        <div className="tabs-body">

            <div className="tab-content" id="myTabContent">
                <div
                    className={`tab-pane fade show active`}
                    id="buyer"
                    role="tabpanel"
                    aria-labelledby="buyer-tab"
                >
                    {faq.length ? (
                        <div
                            className="accordion"
                            id="accordionExample"
                        >
                            {faq.map(
                                (item, index) => {
                                    const question =
                                        sanitizedText(
                                            lang === "en"
                                                ? item.question
                                                : item.question_ar ||
                                                ""
                                        );
                                    const answer =
                                        sanitizedText(
                                            lang === "en"
                                                ? item.answer
                                                : item.answer_ar ||
                                                ""
                                        );
                                    return (
                                        <div
                                            className="accordion-item"
                                            key={index}
                                        >
                                            <h2
                                                className="accordion-header"
                                                id={`headingOne_${item.id}`}
                                            >
                                                <button
                                                    className={`accordion-button ${index > 0 ? "collapsed" : ""}`}
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapseOne_${item.id}`}
                                                    aria-expanded="true"
                                                    aria-controls={`collapseOne_${item.id}`}
                                                    dangerouslySetInnerHTML={
                                                        question
                                                    }
                                                ></button>
                                            </h2>
                                            <div
                                                id={`collapseOne_${item.id}`}
                                                className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                                aria-labelledby={`headingOne_${item.id}`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div
                                                    className="accordion-body"
                                                    dangerouslySetInnerHTML={
                                                        answer
                                                    }
                                                ></div>
                                            </div>
                                        </div>
                                    );
                                }
                            )}
                        </div>
                    ) : (
                        <div className="text-center">
                            <p>
                                <img
                                    src="img/no-property-found.png"
                                    alt=""
                                />
                            </p>
                            <h4>{t("No Record Found")}</h4>
                        </div>
                    )}
                </div>

            </div>
        </div>

    );
}

export default Faq;
